import type { ActiveTools, ToolVariant } from '../types'

export const getDefaultTool = <T extends string>(tools: ToolVariant<T>[][]): ActiveTools<T> => {
  const flattened = tools.flat()
  const firstSelectableTool = flattened.find(tool => tool.type === 'select')?.toolId
  const defaultActive = firstSelectableTool ?? null

  return { select: defaultActive, activate: new Set() }
}
